import React from 'react';

interface LaminationSpecs {
  adhesiveLamination: string;
  laminationCatalyst: string;
  trilaminationAdhesive: string;
  trilaminationCatalyst: string;
}

interface LaminationSectionProps {
  specs: LaminationSpecs;
  onChange: (key: string, value: string) => void;
  disabled?: boolean;
}

const cellClass = 'px-3 py-2 text-xs font-semibold text-gray-600 uppercase tracking-wide bg-gray-50 border border-gray-300 w-44';
const inputClass = 'w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:ring-1 focus:ring-blue-400 focus:border-blue-400 bg-white disabled:bg-gray-50';

const LaminationSection: React.FC<LaminationSectionProps> = ({ specs, onChange, disabled }) => {
  return (
    <div className="border rounded-lg p-6 bg-white">
      <h4 className="text-lg font-semibold mb-5 text-blue-700 border-b pb-2 flex items-center gap-2">
        <span>🖨️</span> 3.1. Laminación
      </h4>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <tbody>
            {/* Row 1: ADHESIVO LAMINACIÓN | CATALIZADOR LAMINACIÓN */}
            <tr>
              <td className={cellClass}>ADHESIVO LAMINACIÓN</td>
              <td className="px-2 py-2 border border-gray-300">
                <input
                  type="text"
                  className={inputClass}
                  placeholder="Captura"
                  value={specs.adhesiveLamination}
                  onChange={(e) => onChange('adhesiveLamination', e.target.value)}
                  disabled={disabled}
                />
              </td>
              <td className="w-4" />
              <td className={cellClass}>CATALIZADOR LAMINACIÓN</td>
              <td className="px-2 py-2 border border-gray-300">
                <input
                  type="text"
                  className={inputClass}
                  placeholder="Captura"
                  value={specs.laminationCatalyst}
                  onChange={(e) => onChange('laminationCatalyst', e.target.value)}
                  disabled={disabled}
                />
              </td>
            </tr>

            {/* Row 2: ADHESIVO TRI LAMINACIÓN | CATALIZADOR TRILAMINADOS */}
            <tr>
              <td className={cellClass}>ADHESIVO TRI LAMINACIÓN</td>
              <td className="px-2 py-2 border border-gray-300">
                <input
                  type="text"
                  className={inputClass}
                  placeholder="Captura"
                  value={specs.trilaminationAdhesive}
                  onChange={(e) => onChange('trilaminationAdhesive', e.target.value)}
                  disabled={disabled}
                />
              </td>
              <td className="w-4" />
              <td className={cellClass}>CATALIZADOR TRILAMINADOS</td>
              <td className="px-2 py-2 border border-gray-300">
                <input
                  type="text"
                  className={inputClass}
                  placeholder="Captura"
                  value={specs.trilaminationCatalyst}
                  onChange={(e) => onChange('trilaminationCatalyst', e.target.value)}
                  disabled={disabled}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LaminationSection;
